import { useTranslation } from 'react-i18next';
import type { WidgetWorkspaceWidgetWorkspaceReadModel } from '@r/api/generated/client.schemas.ts';
import { getWidgetSlidesFromConfigurations } from '@r/helpers/widget-workspace-slides.ts';
import { WidgetContentBlock } from '@r/components/widget/widget-content-block.tsx';

type WidgetWorkspace = WidgetWorkspaceWidgetWorkspaceReadModel;

/**
 * Liste verticale des blocs CTA d’une page.
 * La page filtre déjà les workspaces actifs / planifiés ; ici on mappe configs → slides → UI.
 */
const WidgetHome = ({ widgetWorkspaces }: { widgetWorkspaces: WidgetWorkspace[] }) => {
  const { t } = useTranslation();
  const workspaces = widgetWorkspaces ?? [];

  return (
    <div className="flex relative flex-col w-full grow">
      <div>
        {workspaces.length > 0 ? (
          <div className="min-w-[250px] space-y-4">
            {workspaces.map((workspace) => {
              const slides = getWidgetSlidesFromConfigurations(
                workspace.widgetItemConfigurations ?? []
              );
              return <WidgetContentBlock key={workspace.id} slides={slides} />;
            })}
          </div>
        ) : (
          <p className="text-gray-500">{t('home.widget.no.widget')}</p>
        )}
      </div>
    </div>
  );
};

export default WidgetHome;
